const siteConfig = {
  brandName: "gorequartz",
  logo: "/brand/logo.svg",
  metaTitle: "gorequartz | Gourmet food, gifts & artisan ingredients",
  tagline: "Exceptional food, thoughtfully sourced.",
  description:
    "A modern gourmet market for artisan cheese, charcuterie, seafood, pantry essentials, fresh bakery goods, and memorable gifts.",
  contact: {
    email: "range@gorequartz.fun",
    address: "28 Orchard Market, New York, NY 10002",
    supportHours: "Monday–Friday, 9:00 AM–6:00 PM ET",
    hours: "Monday–Friday, 9:00 AM–6:00 PM ET",
  },
  currency: "USD",
  locale: "en-US",
  standardShippingRate: 9.99,
  storageKeys: {
    cart: "gorequartz.cart",
    wishlist: "gorequartz.wishlist",
    promo: "gorequartz.promo",
  },
};

export { siteConfig };
export default siteConfig;
